import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PdfViewComponent } from './pdf-view/pdf-view.component';
import { ConfirmationModalComponent } from 'src/app/generic-components/confirmation-modal/confirmation-modal.component';

@Component({
    selector: 'app-manage-documents',
    templateUrl: './manage-documents.component.html',
    styleUrls: ['./manage-documents.component.css'],
    providers: [NgxSpinnerService]
})
export class ManageDocumentsComponent implements OnInit {
    displayedColumns: string[] = ['name', 'uploaded', 'actions'];
    @ViewChild('userFile', { static: true }) userFile: ElementRef;
    document: File;
    docs: any;
    documentDate: any;
    user: any = {
        firstName: "",
        lastName: ""
    };
    documents: any = [];


    constructor(
        private apiService: ApiService,
        private http: HttpClient,
        private translate: TranslateService,
        public functionsService: FunctionsService,
        private spinner: NgxSpinnerService,
        private route: ActivatedRoute,
        private modalService: NgbModal,
    ) {
        this.functionsService.setTitle('manage_documents.title');
        this.documentDate = functionsService;
    }
    lang: any = localStorage.getItem("language");

    ngOnInit() {
        this.spinner.show();
        this.getUser();
    }

    handleDocumentUpload(files: FileList) {
        if (files.length === 0) {
            document.getElementById("fileLabel").innerHTML = "";
            this.document = null;
            return;
        }
        this.document = files.item(0);
        if(document.getElementById("doc-err").innerHTML != ""){
            document.getElementById("doc-err").innerHTML = "";
            this.translate.onLangChange.subscribe(() => {
                document.getElementById("doc-err").innerHTML = "";
            });
        }
        document.getElementById("fileLabel").innerHTML = this.document.name;
        if (this.document.type != "application/pdf" && this.document.type != "image/png" && this.document.type != "image/jpeg") {
            //Show error in window
            document.getElementById("doc-err").innerHTML = this.translate.instant('profile.upload_format_err');
            this.translate.onLangChange.subscribe(() => {
                document.getElementById("doc-err").innerHTML = this.translate.instant('profile.upload_format_err');
            });
            this.document = null;
        } else if ((this.document.type == "application/pdf" && this.document.size > 12000000) || ((this.document.type == "image/png" || this.document.type == "image/jpeg") && this.document.size > 5000000)) {
            document.getElementById("doc-err").innerHTML = this.translate.instant('profile.upload_size_err');
            this.translate.onLangChange.subscribe(() => {
                document.getElementById("doc-err").innerHTML = this.translate.instant('profile.upload_size_err');
            });
            this.document = null;
        } else {
            const reader = new FileReader();
            reader.readAsDataURL(this.document);
        }
    }

    isBreadcrumbFinal(breadcrumb: string): any {
        return (breadcrumb === "manageDocuments") ? true : false;
    }

    getDocuments() {
        this.apiService.getDocuments(this.user.userId)
            .subscribe(resp => {
                this.documents = resp;
                this.spinner.hide();
            }, err => {
                this.spinner.hide();
                console.error(err);
            });
    }

    saveDocument() {
        this.spinner.show();
        if(document.getElementById("doc-err").innerHTML != ""){
            document.getElementById("doc-err").innerHTML = "";
            this.translate.onLangChange.subscribe(() => {
                document.getElementById("doc-err").innerHTML = "";
            });
        }
        this.apiService.uploadDocument(this.user.userId, this.document)
            .subscribe(() => {
                document.getElementById("fileLabel").innerHTML = "";
                this.document = null;
                this.userFile = null;
                this.getDocuments();
            }, err => {
                if(err["error"]["content"] == "max_documents"){
                    document.getElementById("doc-err").innerHTML = this.translate.instant('profile.max_docs');
                    this.translate.onLangChange.subscribe(() => {
                        document.getElementById("doc-err").innerHTML = this.translate.instant('profile.max_docs');
                    });
                }
                else{
                    document.getElementById("doc-err").innerHTML = this.translate.instant('profile.upload_err');
                    this.translate.onLangChange.subscribe(() => {
                        document.getElementById("doc-err").innerHTML = this.translate.instant('profile.upload_err');
                    });
                }
                this.spinner.hide();
            }
        );
    }

    downloadDocument(name: string, path: string) {
        this.http.get(path, { responseType: 'blob', observe: 'response' })
            .subscribe(response => {
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(response.body);
                link.download = name;
                link.click();
            });
    }

    getUser() {
        this.apiService.getProfile(this.route.snapshot.paramMap.get('id'))
            .subscribe(
                data => {
                    this.user = data;
                    this.getDocuments();
                },
                error => {
                    this.functionsService.errorHandler(error["status"]);
                    this.spinner.hide();
                }
            );
    }

    public viewDocumentModal(document) {
        if(document.name.slice(-3) == "pdf"){
            const modalRef = this.modalService.open(PdfViewComponent, { size: 'xl' });
            modalRef.componentInstance.fileToView = document;
            modalRef.result.then(() => this.getDocuments());
        }
        else{
            this.functionsService.openImage(document.path);
        }
    }

    deleteDocument(document) {
        const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
        confirmModalRef.componentInstance.title = this.translate.instant('user.delete_document');
        confirmModalRef.componentInstance.message = this.translate.instant('user.delete_document_prompt')+"'"+document.name+"'?";
        confirmModalRef.result.then(confirmed => {
            if (confirmed) {
                this.spinner.show();
                this.apiService.deleteDocument(document.id)
                    .subscribe(resp => {
                        this.getDocuments();
                    }, err => {
                        this.spinner.hide();
                        console.error(err);
                    });
            }
        });
    }
}
